module.exports = __webpack_public_path__ + "img/电信.911437a1.jpg";